<mat-icon
  *ngIf="variablesReady"
  class="dynamic-content-icon"
  aria-label="dynamic-content"
  (click)="openDialog()"
  [glxyTooltip]="'EMAIL_BUILDER.DYNAMIC_COMPONENT_SELECTOR.INSERT_DYNAMIC_CONTENT' | translate"
>
  data_object
</mat-icon>
